import { useNavigate, useLocation } from 'react-router-dom';
import Lottie from 'lottie-react';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { CloseIcon } from 'Asset/icon';
import HelpHostRequesting from 'Asset/animate/help-host-requesting.json';
import HelpHostNoOperator from 'Asset/animate/help-host-no-operator.json';
import { TextBold, TextMedium, TextRegular } from 'UiKit/typography';
import ButtonLink from 'UiKit/button/buttonLink';
import { useAppSystem } from 'Store/app';

import CardRequestInfo from 'View/host-help-partner/component/card-request-info';
import useCancelHelpRequest from 'View/host-help-partner/hook/useCancelHelpRequest';
import ProgressBar from 'View/host-help-partner/component/progress-bar';

import styles from './styles.module.css';

const Requesting = ({ helpRequest }) => {
  const { t } = useTranslation('host-help-partner');
  const navigate = useNavigate();
  const { key } = useLocation();
  const { onChangeAppSystem } = useAppSystem();
  const onOpenModalCancel = useCancelHelpRequest({ helpRequest });

  const closeTarget = key !== 'default' ? -1 : '/host';

  const isOperatorExist = helpRequest?.activeOperators?.length > 0;
  const lottieGif = isOperatorExist ? HelpHostRequesting : HelpHostNoOperator;
  const title = isOperatorExist ? t('searching.title') : t('searching.no_operator_title');
  const description = isOperatorExist ? t('searching.description') : t('searching.no_operator_description');

  const onClose = () => {
    navigate(closeTarget);
    onChangeAppSystem({ isHideMobileNavBar: false });
  };

  return (
    <Box className={styles['requesting__container']}>
      {/* Head */}

      <Box className={styles['requesting__section--head']}>
        <CloseIcon size="18px" onClick={onClose} className={styles['requesting__head--icon']} />
        <TextMedium className={styles['requesting__head--title']}>{t('asking_for_help.title')}</TextMedium>
      </Box>

      {/* Content */}

      <Box className={styles['requesting__section--content']}>
        <Lottie animationData={lottieGif} loop={true} />

        <Box className={styles['requesting__container--text']}>
          <TextBold className={styles['requesting__text--title']}>{title}</TextBold>
          <TextRegular className={styles['requesting__text--description']}>{description}</TextRegular>
        </Box>

        <ProgressBar cancelDuration={helpRequest?.cancelDuration} taskId={helpRequest?.taskId} />
        <CardRequestInfo data={helpRequest} />
      </Box>

      {/* Footer */}

      <Box className={styles['requesting__section--footer']}>
        <ButtonLink className={styles['requesting__button']} color="var(--color-error50)" onClick={onOpenModalCancel}>
          {t('common:cancel')}
        </ButtonLink>
      </Box>
    </Box>
  );
};

export default Requesting;
